import SectionFoundation from "../../../components/LandingPage/AboutSection/SectionFoundation";
import FloatingWhatsapp from "../../../components/LandingPage/FloatingWhatsapp";
import TabTitle from "../../../utils/TabTitle";

const AboutPage = () => {
    TabTitle("Tentang - Satu Langkah");
    return (
        <>
        <SectionFoundation />
        </>
    );
}

export default AboutPage;